// @ts-check
import { useCallback } from 'react';
import { debounce } from '@codex/helpers';
import useEventListener from '../useEventListener';

const useScroll = (callback, timeout = 150, disabled = false) => {
  if (disabled) return;

  if (typeof callback !== 'function') {
    throw new Error('useScroll: callback is not a function');
  }

  const handleScroll = useCallback(
    debounce(() => callback(), timeout, true),
    []
  );

  useEventListener('scroll', handleScroll, { passive: true });
};

/* @component */
export default useScroll;
